import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Quickly build precisely personalized, AI-powered chatbots using any LLM of your choice`,
  description: `With the CustomerAI Personalization Engine, businesses no longer have to struggle with the technical difficulties of securely ingesting customer data into LLMs to build personalized chatbots for online recommendations, self-service marketing and pre-sales, support, or agent assistance. The LLM-agnostic Personalization Engine provides an API that taps into Segment’s customer data platform (CDP) to discern and extract only the most relevant information for every interaction while keeping the customer data itself safe and secure.`,
}

const BuildPersonalizedChatbots: FC = () => {
  return (
    <SectionBase variant="noCopy">
      <StyledSectionContents>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </StyledSectionContents>
    </SectionBase>
  )
}

export default BuildPersonalizedChatbots

const StyledSectionContents = styled(Section.Contents)`
  max-width: 844px;
  margin: 0 auto;
`
